import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { useNavigate } from "react-router-dom";
import generateCaptcha from "../../components/captcha";
import {
  FiSave,
  FiLock,
  FiLink,
  FiActivity,
  FiTrendingUp,
  FiSettings,
} from "react-icons/fi";
import { SiBinance, SiQuizlet } from "react-icons/si";
import { IoLogoUsd, IoWallet, IoGameController } from "react-icons/io5";
import { MdCurrencyRupee, MdOutlineSensorOccupied } from "react-icons/md";
import {
  FaFacebookSquare,
  FaPaypal,
  FaTelegramPlane,
  FaWhatsapp,
} from "react-icons/fa";
import { FaRegStarHalfStroke } from "react-icons/fa6";

const Controller = () => {
  const [loader, setLoader] = useState(false);

  // Main Panel States
  const [coin_value_rs, setCoin_value_rs] = useState(1);
  const [coin_value_usd, setCoin_value_usd] = useState(1);

  // Game Range States
  const [Game_Scratch_Starting_rang, setGame_Scratch_Starting_rang] =
    useState(1);
  const [Game_Scratch_Ending_rang, setGame_Scratch_Ending_rang] = useState(2);
  const [Game_Scratch_limit, setGame_Scratch_limit] = useState(10);
  const [Game_Captcha_Starting_rang, setGame_Captcha_Starting_rang] =
    useState(1);
  const [Game_Captcha_Ending_rang, setGame_Captcha_Ending_rang] = useState(2);
  const [Game_Captcha_limit, setGame_Captcha_limit] = useState(10);

  const [App_Id, setApp_Id] = useState("");
  const [Whatsapp_url, setWhatsapp_url] = useState("");
  const [Telegram_url, setTelegram_url] = useState("");
  const [Quiz_url, setQuiz_url] = useState("");
  const [Game_url, setGame_url] = useState("");

  const [w_upi, setW_upi] = useState(true);
  const [w_paypal, setW_paypal] = useState(true);
  const [w_binance, setW_binance] = useState(true);

  const [facebook_app_id, setFacebook_app_id] = useState("");
  const [facebook_client_token, setFacebook_client_token] = useState("");
  const [pubscale_id, setPubscale_id] = useState("");
  const [geemee_id, setGeemee_id] = useState("");
  const [geemee_api_key, setGeemee_api_key] = useState("");
  const [coin_review, setCoin_review] = useState(1);

  const [Game_Scratch_Status, setGame_Scratch_Status] = useState(true);
  const [Game_Captcha_Status, setGame_Captcha_Status] = useState(true);
  const [referral_coin, setReferral_coin] = useState(0);

  const [Referral_limit, setReferral_limit] = useState(1);
  const [Review_limit, setReview_limit] = useState(1);
  const [Whatsapp_limit, setWhatsapp_limit] = useState(1);
  const [Telegram_limit, setTelegram_limit] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);
    try {
      const resp = await Calling.GetController();
      const { status, message, data } = resp;
      if (status) {
        setCoin_value_rs(data?.coin_value_rs);
        setCoin_value_usd(data?.coin_value_usd);
        setGame_Scratch_Starting_rang(data?.Game_Scratch_Starting_rang);
        setGame_Scratch_Ending_rang(data?.Game_Scratch_Ending_rang);
        setGame_Scratch_limit(data?.Game_Scratch_limit);
        setGame_Captcha_Starting_rang(data?.Game_Captcha_Starting_rang);
        setGame_Captcha_Ending_rang(data?.Game_Captcha_Ending_rang);
        setGame_Captcha_limit(data?.Game_Captcha_limit);
        setWhatsapp_url(data?.Whatsapp_url || "");
        setTelegram_url(data?.Telegram_url || "");
        setQuiz_url(data?.Quiz_url || "");
        setGame_url(data?.Game_url || "");
        setW_upi(data?.w_upi ?? true);
        setW_paypal(data?.w_paypal ?? true);
        setW_binance(data?.w_binance ?? true);
        setGame_Scratch_Status(data?.Game_Scratch_Status ?? true);
        setGame_Captcha_Status(data?.Game_Captcha_Status ?? true);
        setApp_Id(data?.App_Id || "");
        setFacebook_app_id(data?.facebook_app_id);
        setFacebook_client_token(data?.facebook_client_token);
        setPubscale_id(data?.pubscale_id || "");
        setGeemee_id(data?.geemee_id || "");
        setGeemee_api_key(data?.geemee_api_key || "");
        setCoin_review(data?.coin_review);
        setReferral_coin(data?.referral_coin);
        setTelegram_limit(data?.Telegram_limit);
        setWhatsapp_limit(data?.Whatsapp_limit);
        setReview_limit(data?.Review_limit);
        setReferral_limit(data?.Referral_limit);
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      navigate("/Error");
    } finally {
      setLoader(false);
    }
  };

  const handleFacebook = async (e) => {
    e.preventDefault();
    const content = `You are about to update pay amount. To confirm, please solve this math problem`;
    const check = generateCaptcha(content);
    if (!check) return toast.error("Ans is not correct", { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.setControllerFacebook({
        facebook_app_id,
        facebook_client_token,
      });
      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error("Failed to update Ads Position");
      navigate("/Error");
    } finally {
      setLoader(false);
    }
  };

  // Saves App Id + PubScale Id + Geemee Id together
  const handleAppIds = async (e) => {
    e.preventDefault();
    const content = `You are about to update App IDs. Solve this math problem to confirm`;
    const check = generateCaptcha(content);
    if (!check)
      return toast.error("Answer is not correct", { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.setControllerAppIds({
        App_Id: App_Id?.trim() || "",
        pubscale_id: pubscale_id?.trim() || "",
        geemee_id: geemee_id?.trim() || "",
        geemee_api_key: geemee_api_key?.trim() || "",
      });
      if (resp?.status) {
        toast.success(resp?.message);
        fetchData();
      } else {
        toast.error(resp?.message);
      }
    } catch {
      toast.error("Failed to update App IDs");
      navigate("/Error");
    } finally {
      setLoader(false);
    }
  };

  const handleCheckboxChange = async (name, value) => {
    const content = `You are about to update. To confirm, please solve this math problem.`;
    const isCaptchaValid = generateCaptcha(content);
    if (!isCaptchaValid) {
      return toast.error("Captcha answer is not correct", { autoClose: 2000 });
    }
    setLoader(true);
    try {
      const resp = await Calling.UpdateControllerStatus({
        name,
        status: !value,
      });
      if (resp?.status) {
        toast.success("Updated successfully");
        if (name === "exclusive_module") {
          window.location.reload();
        }
      } else {
        toast.error(resp.message || "Failed to update");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update");
      navigate("/Error");
    } finally {
      setLoader(false);
      fetchData();
    }
  };

  const handleFieldUpdate = async (field, value) => {
    if (typeof value === "number" && value < 0) {
      return toast.error("Value must be 0 or more");
    }
    const content = `You are about to update ${field}. Solve this math problem to confirm`;
    const check = generateCaptcha(content);
    if (!check)
      return toast.error("Answer is not correct", { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.SetFieldNumber({ field, coin: value });
      if (resp?.status) {
        toast.success(resp?.message);
        fetchData();
      } else {
        toast.error(resp?.message);
      }
    } catch {
      toast.error("Failed to update field");
      navigate("/Error");
    } finally {
      setLoader(false);
    }
  };

  const handleRangeUpdate = async (
    gameType,
    startValue,
    endValue,
    limitValue
  ) => {
    if (startValue < 0 || endValue < 0 || limitValue < 0) {
      return toast.error("Range and limit values must be 0 or more");
    }
    if (startValue >= endValue) {
      return toast.error("Starting range must be less than ending range");
    }
    const content = `You are about to update ${gameType} range. Solve this math problem to confirm`;
    const check = generateCaptcha(content);
    if (!check)
      return toast.error("Answer is not correct", { autoClose: 2000 });
    setLoader(true);
    try {
      let resp;
      if (gameType === "Scratch") {
        resp = await Calling.UpdateControllerScratchRange({
          Game_Scratch_Starting_rang: startValue,
          Game_Scratch_Ending_rang: endValue,
          Game_Scratch_limit: limitValue,
        });
      } else if (gameType === "Captcha") {
        resp = await Calling.UpdateControllerCaptchaRange({
          Game_Captcha_Starting_rang: startValue,
          Game_Captcha_Ending_rang: endValue,
          Game_Captcha_limit: limitValue,
        });
      }
      if (resp?.status) {
        toast.success(resp?.message);
        fetchData();
      } else {
        toast.error(resp?.message);
      }
    } catch (error) {
      console.error("Update Range Error:", error);
      toast.error("Failed to update range");
      navigate("/Error");
    } finally {
      setLoader(false);
    }
  };

  const handleUrlSubmit = async (field, value) => {
    const content = `You are about to update ${field}. Solve this math problem to confirm`;
    const check = generateCaptcha(content);
    if (!check)
      return toast.error("Answer is not correct", { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.UpdateControllerStatus({
        name: field,
        status: value,
      });
      if (resp?.status) {
        toast.success(resp?.message);
        fetchData();
      } else {
        toast.error(resp?.message);
      }
    } catch {
      toast.error("Failed to update URL");
      navigate("/Error");
    } finally {
      setLoader(false);
    }
  };

  const handlePw = () => navigate("/manage/changePw/");

  // Reusable Toggle Component
  const Toggle = ({ checked, onChange }) => (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only peer"
      />
      <div className="w-12 h-6 bg-gray-200 rounded-full peer-focus:ring-4 peer-focus:ring-main-blue/30 peer-checked:bg-main-blue transition-all relative">
        <div
          className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow-sm transition-transform duration-300 ${
            checked ? "translate-x-6" : "translate-x-0"
          }`}
        />
      </div>
    </label>
  );

  // Reusable Value Card Component
  const ValueCard = ({ icon, label, desc, value, setValue, onSave }) => (
    <div className="bg-main-th rounded-2xl p-4 sm:p-6 border-2 border-main-blue/20 hover:border-main-blue/40 transition-all duration-300 shadow-md">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-6">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-main-blue rounded-xl flex items-center justify-center shadow-lg shrink-0">
            {icon}
          </div>
          <div>
            <label className="text-base sm:text-xl font-bold text-main-font block">
              {label}
            </label>
            <p className="text-xs sm:text-sm text-main-subfont mt-1">{desc}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto">
          <input
            type="number"
            value={value}
            min="0"
            onChange={(e) => setValue(Number(e.target.value))}
            className="w-full sm:w-24 px-3 py-2.5 sm:py-3 border-2 border-main-border rounded-xl text-center text-lg sm:text-xl font-bold text-main-font focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white"
          />
          <button
            onClick={onSave}
            className="px-3 sm:px-4 py-2.5 sm:py-3 bg-main-blue text-white rounded-xl hover:bg-main-blue/80 flex items-center gap-1 sm:gap-2 font-semibold shadow-md hover:shadow-lg transition-all duration-300 shrink-0"
          >
            <FiSave className="text-base sm:text-lg" />
            <span className="hidden sm:inline">Save</span>
          </button>
        </div>
      </div>
    </div>
  );

  // Reusable Game Toggle Card
  const GameToggleCard = ({ label, value, handler, icon, color }) => (
    <div
      className={`flex flex-col items-center justify-between py-6 sm:py-8 px-4 border rounded-2xl shadow-sm hover:shadow-lg transition-all duration-200 ${color}`}
    >
      <span className="flex items-center gap-2 sm:gap-3 text-base sm:text-lg font-semibold text-main-font mb-3">
        {icon}
        {label}
      </span>
      <Toggle checked={value} onChange={handler} />
      <span
        className={`text-sm font-medium mt-2 ${
          value ? "text-green-600" : "text-red-500"
        }`}
      >
        {value ? "Enabled" : "Disabled"}
      </span>
    </div>
  );

  // Reusable Range Input
  const RangeInput = ({ label, value, setter, focusColor }) => (
    <div className="bg-main-white rounded-xl p-3 shadow-md hover:shadow-lg transition-all duration-300 border-2 border-main-border">
      <label className="text-xs sm:text-sm text-main-subfont block mb-2 sm:mb-3 uppercase tracking-wide">
        {label}
      </label>
      <input
        type="number"
        value={value}
        min="0"
        onChange={(e) => setter(Number(e.target.value))}
        className={`w-full px-3 sm:px-4 py-2 sm:py-3 border-2 border-main-border rounded-xl text-center text-lg sm:text-xl font-bold text-main-font focus:border-${focusColor} focus:ring-2 focus:ring-${focusColor}/20 outline-none transition-all`}
      />
    </div>
  );

  // Reusable URL Field
  const UrlField = ({ label, icon, value, setter, field, onSave }) => (
    <div className="bg-main-bg rounded-2xl p-4 sm:p-6 border-2 border-main-border hover:border-main-blue/40 transition-all duration-300">
      <label className="flex items-center gap-2 text-main-font font-bold mb-3 sm:mb-4 text-base sm:text-lg">
        <span className="text-xl sm:text-2xl">{icon}</span>
        {label}
      </label>
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
        <input
          type="url"
          value={value}
          onChange={(e) => setter(e.target.value)}
          className="flex-1 border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
          placeholder={`https://example.com/${field.toLowerCase()}`}
        />
        <button
          onClick={onSave}
          className="px-4 sm:px-6 py-2.5 sm:py-3 bg-main-blue text-white rounded-xl hover:bg-main-blue/80 flex items-center justify-center gap-2 font-semibold transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
        >
          <FiSave className="text-base sm:text-lg" />
          Save
        </button>
      </div>
    </div>
  );

  // Reusable Withdraw Card
  const WithdrawCard = ({ label, value, handler, icon, color }) => (
    <div
      className={`flex flex-col items-center justify-between py-6 sm:py-8 px-4 border rounded-2xl shadow-sm hover:shadow-lg transition-all duration-200 ${color}`}
    >
      <span className="flex items-center gap-3 sm:gap-4 mb-3 text-base sm:text-lg font-semibold text-main-font">
        {icon}
        {label}
      </span>
      <Toggle checked={value} onChange={handler} />
      <span
        className={`text-sm font-medium mt-2 ${
          value ? "text-green-600" : "text-red-500"
        }`}
      >
        {value ? "Enabled" : "Disabled"}
      </span>
    </div>
  );
  const colors = {
    blue: "from-blue-500 to-blue-700 border-blue-400",
    green: "from-green-500 to-green-700 border-green-400",
    orange: "from-orange-500 to-orange-700 border-orange-400",
    purple: "from-purple-500 to-purple-700 border-purple-400",
  };

  const LimitComp = ({ icon, label, desc, value, setValue, onSave, color }) => {
    const selectedColor = colors[color] || colors.blue;

    return (
      <div
        className={`rounded-2xl border shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden ${
          selectedColor.split(" ")[2]
        }`}
      >
        {/* Header */}
        <div
          className={`bg-gradient-to-r ${selectedColor} p-4 flex items-center gap-3`}
        >
          <div className="text-white bg-black/20 p-2 rounded-lg">{icon}</div>
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white">{label}</h3>
            <p className="text-sm text-gray-200">{desc}</p>
          </div>
        </div>

        {/* Body */}
        <div className="p-4 flex flex-col sm:flex-row items-center gap-3">
          <input
            type="number"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Enter limit"
            className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
          />

          <button
            onClick={onSave}
            className="px-4 py-2 bg-gray-900 hover:bg-black text-white rounded-lg flex items-center gap-2 transition-all"
          >
            <FiSave /> Save
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      {loader ? (
        <Loader loader={loader} />
      ) : (
        <div className="md:ml-[4.4rem] w-full min-h-screen bg-main-bg px-3 sm:px-4 md:px-6 py-4 sm:py-6">
          {/* Header Section */}
          <div className="w-full mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 sm:mb-8 mt-12 sm:mt-16 gap-4">
              <div>
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-main-font mb-2 flex items-center gap-2 sm:gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-main-blue rounded-xl flex items-center justify-center shadow-lg shrink-0">
                    <FiSettings className="text-white text-xl sm:text-2xl" />
                  </div>
                  Controller Panel
                </h1>
                <p className="text-main-subfont text-sm sm:text-base ml-12 sm:ml-15">
                  Manage your application settings and configurations
                </p>
              </div>
            </div>

            <div className="space-y-4 sm:space-y-6">
              {/* Main Panel - Security & Coin Value */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                {/* Header */}
                <div className="bg-gradient-to-r from-main-blue to-[#ff8c3a] p-4 sm:p-6">
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                    <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                      <FiLock className="text-lg sm:text-xl" />
                      Main Panel
                    </h2>
                    <button
                      onClick={handlePw}
                      className="px-4 sm:px-5 py-2 sm:py-2.5 bg-white/20 backdrop-blur-sm text-white rounded-xl flex items-center gap-2 hover:bg-white/30 transition-all duration-300 font-medium border border-white/20 text-sm sm:text-base"
                    >
                      <FiLock className="text-sm sm:text-base" />
                      Change Password
                    </button>
                  </div>
                </div>

                {/* Grid Container */}
                <div className="p-4 sm:p-6 md:p-8 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
                  <ValueCard
                    icon={
                      <MdCurrencyRupee className="text-white text-2xl sm:text-3xl" />
                    }
                    label="Coin Rs"
                    desc="Set the base Rs coin value for transactions"
                    value={coin_value_rs}
                    setValue={setCoin_value_rs}
                    onSave={() =>
                      handleFieldUpdate("coin_value_rs", coin_value_rs)
                    }
                  />
                  <ValueCard
                    icon={
                      <IoLogoUsd className="text-white text-2xl sm:text-3xl" />
                    }
                    label="Coin USD"
                    desc="Set the base USD coin value for transactions"
                    value={coin_value_usd}
                    setValue={setCoin_value_usd}
                    onSave={() =>
                      handleFieldUpdate("coin_value_usd", coin_value_usd)
                    }
                  />
                  <ValueCard
                    icon={
                      <FiTrendingUp className="text-white text-2xl sm:text-3xl" />
                    }
                    label="Referral Coin"
                    desc="Set the reward coin amount for user referrals"
                    value={referral_coin}
                    setValue={setReferral_coin}
                    onSave={() =>
                      handleFieldUpdate("referral_coin", referral_coin)
                    }
                  />
                  <ValueCard
                    icon={
                      <FaRegStarHalfStroke className="text-white text-2xl sm:text-3xl" />
                    }
                    label="Coin Review"
                    desc="Set required coin amount for review unlock"
                    value={coin_review}
                    setValue={setCoin_review}
                    onSave={() => handleFieldUpdate("coin_review", coin_review)}
                  />
                </div>
              </div>

              {/* Limit Box Section */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                <div className="bg-gradient-to-r from-main-blue to-[#ff8c3a] p-4 sm:p-6">
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                    <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                      <FiLock className="text-lg sm:text-xl" />
                      Share Limit Control
                    </h2>
                  </div>
                </div>

                <div className="p-4 sm:p-6 md:p-8 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
                  {/* Referral Limit */}
                  <LimitComp
                    icon={<FiTrendingUp className="text-white text-2xl" />}
                    label="Referral Limit"
                    desc="Referral earning limit"
                    value={Referral_limit}
                    setValue={setReferral_limit}
                    onSave={() =>
                      handleFieldUpdate("Referral_limit", Referral_limit)
                    }
                    color="blue"
                  />

                  {/* Review Limit */}
                  <LimitComp
                    icon={<FiActivity className="text-white text-2xl" />}
                    label="Review Limit"
                    desc="Review task limit"
                    value={Review_limit}
                    setValue={setReview_limit}
                    onSave={() =>
                      handleFieldUpdate("Review_limit", Review_limit)
                    }
                    color="green"
                  />

                  {/* Whatsapp Share Limit */}
                  <LimitComp
                    icon={<FiLink className="text-white text-2xl" />}
                    label="WhatsApp Share Limit"
                    desc="WhatsApp share task limit"
                    value={Whatsapp_limit}
                    setValue={setWhatsapp_limit}
                    onSave={() =>
                      handleFieldUpdate("Whatsapp_limit", Whatsapp_limit)
                    }
                    color="orange"
                  />

                  {/* Telegram Share Limit */}
                  <LimitComp
                    icon={<FiLink className="text-white text-2xl" />}
                    label="Telegram Share Limit"
                    desc="Telegram share task limit"
                    value={Telegram_limit}
                    setValue={setTelegram_limit}
                    onSave={() =>
                      handleFieldUpdate("Telegram_limit", Telegram_limit)
                    }
                    color="purple"
                  />
                </div>
              </div>

              {/* Game Status Controller */}
              <div className="bg-main-white rounded-2xl shadow-lg border border-main-border p-4 sm:p-6 md:p-8">
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <IoGameController className="text-main-blue text-xl sm:text-2xl" />
                  <h2 className="text-xl sm:text-2xl font-bold text-main-font">
                    Game Status Control
                  </h2>
                </div>
                <p className="text-main-subfont text-xs sm:text-sm mb-4 sm:mb-6">
                  Toggle to enable or disable each game module for all users.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <GameToggleCard
                    label="Scratch Game"
                    value={Game_Scratch_Status}
                    handler={() =>
                      handleCheckboxChange(
                        "Game_Scratch_Status",
                        Game_Scratch_Status
                      )
                    }
                    icon={
                      <FiActivity
                        size={22}
                        className="text-cyan-600 sm:w-6 sm:h-6"
                      />
                    }
                    color="border-cyan-200 bg-cyan-50"
                  />
                  <GameToggleCard
                    label="Captcha Game"
                    value={Game_Captcha_Status}
                    handler={() =>
                      handleCheckboxChange(
                        "Game_Captcha_Status",
                        Game_Captcha_Status
                      )
                    }
                    icon={
                      <FiTrendingUp
                        size={22}
                        className="text-blue-600 sm:w-6 sm:h-6"
                      />
                    }
                    color="border-blue-200 bg-blue-50"
                  />
                </div>
              </div>

              {/* Game Range Panel */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                <div className="bg-primary-purple p-4 sm:p-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                    <FiActivity className="text-lg sm:text-xl" />
                    Game Range Panel
                  </h2>
                </div>

                <div className="p-4 sm:p-6 md:p-8 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
                  {/* Scratch Game */}
                  <div className="bg-main-bg rounded-2xl p-4 sm:p-6 border-2 border-main-border hover:border-main-blue/40 transition-all duration-300 shadow-sm hover:shadow-lg">
                    <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-secondary-cyanDark rounded-xl flex items-center justify-center shadow-md shrink-0">
                        <FiActivity className="text-white text-lg sm:text-xl" />
                      </div>
                      <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-main-font">
                        Scratch Game Config
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 md:gap-5 mb-4 sm:mb-6">
                      <RangeInput
                        label="Starting Range"
                        value={Game_Scratch_Starting_rang}
                        setter={setGame_Scratch_Starting_rang}
                        focusColor="secondary-cyanDark"
                      />
                      <RangeInput
                        label="Ending Range"
                        value={Game_Scratch_Ending_rang}
                        setter={setGame_Scratch_Ending_rang}
                        focusColor="secondary-cyanDark"
                      />
                      <RangeInput
                        label="Daily Limit"
                        value={Game_Scratch_limit}
                        setter={setGame_Scratch_limit}
                        focusColor="secondary-cyanDark"
                      />
                    </div>

                    <div className="flex justify-end">
                      <button
                        onClick={() =>
                          handleRangeUpdate(
                            "Scratch",
                            Game_Scratch_Starting_rang,
                            Game_Scratch_Ending_rang,
                            Game_Scratch_limit
                          )
                        }
                        className="w-full sm:w-auto px-4 sm:px-8 py-2.5 sm:py-3 bg-secondary-cyanDark text-white rounded-xl hover:bg-secondary-teal flex items-center justify-center gap-2 font-semibold shadow-md hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
                      >
                        <FiSave className="text-base sm:text-lg" />
                        Update Scratch Range
                      </button>
                    </div>
                  </div>

                  {/* Captcha Game */}
                  <div className="bg-main-bg rounded-2xl p-4 sm:p-6 border-2 border-main-border hover:border-main-blue/40 transition-all duration-300 shadow-sm hover:shadow-lg">
                    <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary-blue rounded-xl flex items-center justify-center shadow-md shrink-0">
                        <FiActivity className="text-white text-lg sm:text-xl" />
                      </div>
                      <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-main-font">
                        Captcha Game Config
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 md:gap-5 mb-4 sm:mb-6">
                      <RangeInput
                        label="Starting Range"
                        value={Game_Captcha_Starting_rang}
                        setter={setGame_Captcha_Starting_rang}
                        focusColor="primary-blue"
                      />
                      <RangeInput
                        label="Ending Range"
                        value={Game_Captcha_Ending_rang}
                        setter={setGame_Captcha_Ending_rang}
                        focusColor="primary-blue"
                      />
                      <RangeInput
                        label="Daily Limit"
                        value={Game_Captcha_limit}
                        setter={setGame_Captcha_limit}
                        focusColor="primary-blue"
                      />
                    </div>

                    <div className="flex justify-end">
                      <button
                        onClick={() =>
                          handleRangeUpdate(
                            "Captcha",
                            Game_Captcha_Starting_rang,
                            Game_Captcha_Ending_rang,
                            Game_Captcha_limit
                          )
                        }
                        className="w-full sm:w-auto px-4 sm:px-8 py-2.5 sm:py-3 bg-primary-blue text-white rounded-xl hover:bg-blue-600 flex items-center justify-center gap-2 font-semibold shadow-md hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
                      >
                        <FiSave className="text-base sm:text-lg" />
                        Update Captcha Range
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* URL Configuration Panel */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                <div className="bg-gradient-to-r from-main-blue to-purple-600 p-4 sm:p-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                    <FiLink className="text-lg sm:text-xl" />
                    External Links Configuration
                  </h2>
                </div>

                <div className="p-4 sm:p-6 md:p-8 space-y-4 sm:space-y-5">
                  <UrlField
                    label="WhatsApp Group URL"
                    icon={<FaWhatsapp />}
                    value={Whatsapp_url}
                    setter={setWhatsapp_url}
                    field="Whatsapp_url"
                    onSave={() => handleUrlSubmit("Whatsapp_url", Whatsapp_url)}
                  />
                  <UrlField
                    label="Telegram Channel URL"
                    icon={<FaTelegramPlane />}
                    value={Telegram_url}
                    setter={setTelegram_url}
                    field="Telegram_url"
                    onSave={() => handleUrlSubmit("Telegram_url", Telegram_url)}
                  />
                  <UrlField
                    label="Quiz URL"
                    icon={<SiQuizlet />}
                    value={Quiz_url}
                    setter={setQuiz_url}
                    field="Quiz_url"
                    onSave={() => handleUrlSubmit("Quiz_url", Quiz_url)}
                  />
                  <UrlField
                    label="Game URL"
                    icon={<IoGameController />}
                    value={Game_url}
                    setter={setGame_url}
                    field="Game_url"
                    onSave={() => handleUrlSubmit("Game_url", Game_url)}
                  />
                </div>
              </div>

              {/* Withdrawal Methods Panel */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-4 sm:p-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                    <IoWallet className="text-lg sm:text-xl" />
                    Withdrawal Methods
                  </h2>
                </div>

                <div className="p-4 sm:p-6 md:p-8">
                  <p className="text-main-subfont text-xs sm:text-sm mb-4 sm:mb-6">
                    Enable or disable payment withdrawal methods for users
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
                    <WithdrawCard
                      label="UPI"
                      value={w_upi}
                      handler={() => handleCheckboxChange("w_upi", w_upi)}
                      icon={
                        <MdCurrencyRupee size={24} className="text-green-600" />
                      }
                      color="border-green-200 bg-green-50"
                    />
                    <WithdrawCard
                      label="PayPal"
                      value={w_paypal}
                      handler={() => handleCheckboxChange("w_paypal", w_paypal)}
                      icon={<FaPaypal size={24} className="text-blue-600" />}
                      color="border-blue-200 bg-blue-50"
                    />
                    <WithdrawCard
                      label="Binance"
                      value={w_binance}
                      handler={() =>
                        handleCheckboxChange("w_binance", w_binance)
                      }
                      icon={<SiBinance size={24} className="text-yellow-600" />}
                      color="border-yellow-200 bg-yellow-50"
                    />
                  </div>
                </div>
              </div>

              {/* Facebook Configuration Panel */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 sm:p-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                    <FaFacebookSquare className="text-lg sm:text-xl" />
                    Facebook Integration
                  </h2>
                </div>

                <form
                  onSubmit={handleFacebook}
                  className="p-4 sm:p-6 md:p-8 space-y-4 sm:space-y-5"
                >
                  <div className="bg-main-bg rounded-xl p-4 sm:p-5 border-2 border-main-border">
                    <label className="block text-main-font font-semibold mb-2 sm:mb-3 text-sm sm:text-base">
                      Facebook App ID
                    </label>
                    <input
                      type="text"
                      value={facebook_app_id}
                      onChange={(e) => setFacebook_app_id(e.target.value)}
                      className="w-full border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
                      placeholder="Enter Facebook App ID"
                    />
                  </div>

                  <div className="bg-main-bg rounded-xl p-4 sm:p-5 border-2 border-main-border">
                    <label className="block text-main-font font-semibold mb-2 sm:mb-3 text-sm sm:text-base">
                      Facebook Client Token
                    </label>
                    <input
                      type="text"
                      value={facebook_client_token}
                      onChange={(e) => setFacebook_client_token(e.target.value)}
                      className="w-full border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
                      placeholder="Enter Facebook Client Token"
                    />
                  </div>

                  <div className="flex justify-end pt-2">
                    <button
                      type="submit"
                      className="px-4 sm:px-8 py-2.5 sm:py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 flex items-center gap-2 font-semibold shadow-md hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
                    >
                      <FiSave className="text-base sm:text-lg" />
                      Save Facebook Config
                    </button>
                  </div>
                </form>
              </div>

              {/* App ID Panel */}
              <div className="bg-main-white rounded-2xl shadow-lg overflow-hidden border border-main-border hover:shadow-xl transition-all duration-300">
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-4 sm:p-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2 sm:gap-3">
                    <MdOutlineSensorOccupied className="text-lg sm:text-xl" />
                    Application ID
                  </h2>
                </div>

                <form
                  onSubmit={handleAppIds}
                  className="p-4 sm:p-6 md:p-8 space-y-4 sm:space-y-5"
                >
                  <div className="bg-main-bg rounded-xl p-4 sm:p-5 border-2 border-main-border">
                    <label className="block text-main-font font-semibold mb-2 sm:mb-3 text-sm sm:text-base">
                      App ID
                    </label>
                    <input
                      type="text"
                      value={App_Id}
                      onChange={(e) => setApp_Id(e.target.value)}
                      className="w-full border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
                      placeholder="Enter Application ID"
                    />
                  </div>

                  <div className="bg-main-bg rounded-xl p-4 sm:p-5 border-2 border-main-border">
                    <label className="block text-main-font font-semibold mb-2 sm:mb-3 text-sm sm:text-base">
                      PubScale ID
                    </label>
                    <input
                      type="text"
                      value={pubscale_id}
                      onChange={(e) => setPubscale_id(e.target.value)}
                      className="w-full border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
                      placeholder="Enter PubScale ID"
                    />
                  </div>

                  <div className="bg-main-bg rounded-xl p-4 sm:p-5 border-2 border-main-border">
                    <label className="block text-main-font font-semibold mb-2 sm:mb-3 text-sm sm:text-base">
                      Geemee ID
                    </label>
                    <input
                      type="text"
                      value={geemee_id}
                      onChange={(e) => setGeemee_id(e.target.value)}
                      className="w-full border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
                      placeholder="Enter Geemee ID"
                    />
                  </div>

                  <div className="bg-main-bg rounded-xl p-4 sm:p-5 border-2 border-main-border">
                    <label className="block text-main-font font-semibold mb-2 sm:mb-3 text-sm sm:text-base">
                      Geemee API Key
                    </label>
                    <input
                      type="text"
                      value={geemee_api_key}
                      onChange={(e) => setGeemee_api_key(e.target.value)}
                      className="w-full border-2 border-main-border px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl focus:border-main-blue focus:ring-2 focus:ring-main-blue/20 outline-none transition-all bg-main-white text-main-font text-sm sm:text-base"
                      placeholder="Enter Geemee API Key"
                    />
                  </div>

                  <div className="flex justify-end pt-2">
                    <button
                      type="submit"
                      className="px-4 sm:px-8 py-2.5 sm:py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 flex items-center gap-2 font-semibold shadow-md hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
                    >
                      <FiSave className="text-base sm:text-lg" />
                      Save App ID
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Controller;
